import React from 'react'; 
import { withStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { AccountDisplay, AccountProfile, AccountDetails, Password, Notifications, AccountName } from './components';
 

 // hollywood
 import axios from 'axios';

 import { API_LOCAL } from '../../constants'; 
  
const styles = (theme => ({
  root: {
    padding: 16,
    paddingTop: 180,
  }
}));

export class Account extends React.PureComponent {
  constructor(...args) {
    super(...args);
    this._logoutTimerID = null;
    this._logoutIntervalID = null;

    const { user, updateUser, apiManager, history } = this.props;
    const subscriptionData = localStorage.getItem('subscriptionData');
    this.state = {
      user,
      firstName: user['custom:firstName'],
      lastName: user['custom:lastName'],
      isSubscribed: user['custom:isSubscribed'],
      subExpires: user['custom:subExp'],
      subId: user['sub'],
      email: user['email'],
      phone: user['custom:phone'],
      updateUser,
      apiManager,
      subscriptionData: subscriptionData ? JSON.parse(subscriptionData) : false,
    } 
  }
 
 componentDidMount = async() => {   
 }

  render() {
    const { classes, history } = this.props;
    const { user, updateUser, apiManager, subscriptionData
    } = this.state; 
    return (
    <div className={classes.root}>
      <Grid
        container
        spacing={4}
      >
          <Grid item xs={1} />
          <Grid item xs={11}>
        <Grid
          item

          xs={11}
        >
        <AccountDisplay user={user} updateUser={updateUser} apiManager={apiManager} history={history} subscriptionData={subscriptionData}/>
          {/* <AccountProfile user={user} updateUser={updateUser} apiManager={apiManager} /> */}
         
        </Grid>
        <Grid
          xs={11}
        >
        {/* <AccountDetails user={user}  updateUser={updateUser} apiManager={apiManager} /><br /> */}
        {/* <AccountName  user={user}  updateUser={updateUser} apiManager={apiManager} /><br />
        <Notifications user={user} updateUser={updateUser} apiManager={apiManager} /> <br /> */}
          {/* <Password user={user}  updateUser={updateUser} apiManager={apiManager} /> */}
        </Grid>
        </Grid>
      </Grid>
    </div>
  );
    }
};

Account.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  updateUser: PropTypes.func
};

export default withStyles(styles)(Account); 